/// <amd-module name="VSS/Features/Conduct/Service" />

import * as React from "react";
import * as ReactDOM from "react-dom";

import { IVssPageService } from "VSS/Platform/Page";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { ReportAbuseDialog } from "./Components/ReportAbuse";

export interface IConductService {
    showReportAbuse(): void;
}

class ConductService extends VssService implements IConductService {
    private dialogContainerId = "report-abuse-container";

    public showReportAbuse(): void {
        // Add container element for the dialog
        const dialogContainer = document.createElement("div");
        dialogContainer.id = this.dialogContainerId;
        document.body.appendChild(dialogContainer);

        // Get the host id to report as tenant id
        const pageService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();

        // Show the dialog in the container
        ReactDOM.render(
            React.createElement(ReportAbuseDialog, {
                hostId: pageData!.hostId,
                pageContext: this.pageContext,
                dismiss: this.hideReportAbuse
            }),
            dialogContainer
        );
    }

    private hideReportAbuse = (): void => {
        const dialogContainer = document.getElementById(this.dialogContainerId);
        if (dialogContainer) {
            // Remove the dialog
            ReactDOM.unmountComponentAtNode(dialogContainer);

            // Remove the dialog container
            document.body.removeChild(dialogContainer);
        }
    };
}

Services.add("conduct-service", { serviceFactory: ConductService });
